import Sla from ".";

export const slaRoutes = [
  {
    path: "/sla",
    element: <Sla />,
  },
];
